"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenSchema = exports.TokenTypes = void 0;
const model_schema_1 = require("../base/model.schema");
const yup_1 = require("yup");
exports.TokenTypes = ['multi', 'auth', 'wallboard', 'apikey'];
exports.TokenSchema = model_schema_1.Schema.shape({
    instanceID: (0, yup_1.string)().required(),
    username: (0, yup_1.string)().notRequired(),
    companyID: (0, yup_1.string)().required(),
    expiry: (0, yup_1.number)().required(),
    type: (0, yup_1.mixed)().oneOf(exports.TokenTypes).required(),
    userID: (0, yup_1.string)().notRequired(),
    pluginTokenID: (0, yup_1.string)().notRequired(),
    refreshTokenID: (0, yup_1.string)().notRequired(),
    permissions: (0, yup_1.array)((0, yup_1.string)()).default([]),
    securityRoles: (0, yup_1.array)((0, yup_1.string)()).default([]),
    name: (0, yup_1.string)().notRequired(),
    hierarchyStructure: (0, yup_1.string)().notRequired()
});
